import { Theme } from "../../../components/constants"

export default {
    text: {
        fontSize: "14px",
        color: Theme.TEXT_PRIMARY_BLACK
    },
    userInfoPopupChildren: {
        maxHeight:"100%", 
        height: '100%', 
        paddingBottom: '50px'
    },
    userInfoPopupOverlay: {
        background: "transparent",
        position: "fixed",
        top: "calc(50% + 36px)",
        left: "calc(50% + 40px)",
        transform: "translate(-50%, -50%)",
        transition: "all 0.5s ease-in-out 0s",
        width: "calc(100vw - 78px)",
        height: "calc(100vh - 72px)",
        zIndex: 0,
    },
    userInfoPopupCustom: {
        borderRadius: "0px",
        maxWidth: "100%",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },
    importUserPopupChildren: {
        maxHeight:"100%", 
        paddingBottom: '50px'
    },
    importUserPopupCustom: {
        maxHeight: "95vh", 
        width: '70vw',
        maxWidth: '70vw',
        display: "flex", 
        flexDirection: "column"
    },
    tableBorderTop: {
        borderTop: '0.5px solid rgb(190, 190, 190)'
    },
    search: {
        display: 'flex', 
        gap: '20px', 
        alignItems: 'center'
    },
    buttonPadding: {
        padding: '10px 15px'
    },
    actionsRow: {
        display: 'flex', 
        gap: '15px'
    },
    actionButtons: {
        display: 'flex', 
        gap: '30px'
    },
    mainContainer: {
        display: 'flex', 
        justifyContent: 'space-between', 
        padding:'50px 20px'
    }
}